<template>
    <div class="detectip-box">
        <div class="db-wrapper">
            <div class="db-site-name">Foton Card</div>
            <p class="db-message">因您所在的地區或國家限制，我們無法爲您提供服務。對此造成不便，我們深表歉意。</p>
            <p class="db-message">Due to your IP address, our services are not available in your country or region. We apologize for any inconvenience.</p>
            <div class="db-btns">
                <el-button @click="toLoginPage" class="hover-status" style="background-color:#6AE7B5;border-color:#6AE7B5">
                    <p class="btn-p" style="padding-bottom:3px;">我不是受限國家或地區的公民</p>
                    <p class="btn-p">I am not a citizen of the restricted countries or regions</p>
                </el-button>
                <el-button @click="openDetectDialog" class="dblist-btn">
                    <p class="btn-p" style="padding-bottom:3px;">受限國家列表</p>
                    <p class="btn-p">Restricted List</p>
                </el-button>
            </div>
        </div>
        <el-dialog
        title=""
        :visible.sync="dialogVisible"
        custom-class="detect-dialog"
        width="30%">
        <div class="detect-items">
            <div v-for="(item, i) in detectCountrys" :key="i" class="detect-item">
                <div>{{ item }}</div>
            </div>
        </div>
        <!-- <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
        </span> -->
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            dialogVisible: false,
            detectCountrys: [
                'Islamic Republic of Afghanistan',
                'Republic of the Union of Myanmar',
                'Republic of Burundi',
                "People's Republic of China",
                'Central African Republic',
                'Republic of the Congo',
                'Democratic Republic of the Congo',
                'Republic of Cuba',
                'Islamic Republic of Iran',
                "Republic of Côte d'Ivoire",
                "Democratic People's Republic of Korea",
                'Republic of Liberia',
                'State of Libya',
                'Republic of Nicaragua',
                'Russian Federation',
                'Federal Republic of Somalia',
                'Republic of Zimbabwe',
                'Republic of the Sudan',
                'Republic of South Sudan',
                'Syrian Arab Republic',
                'Bolivarian Republic of Venezuela',
                'Republic of Yemen',
                'Ukraine',
                'Crimea'
            ]
        }
    },
    methods: {
        toLoginPage() {
            // this.$store.commit('setShowChinaWarning', false)
            // localStorage.setItem('bypassRestriction', false)
            // this.$store.dispatch('bypass');
            sessionStorage.setItem('fromNotice', '1');
            setTimeout(() => {
                this.$router.push('/pages/login')
            }, 100)
        },
        openDetectDialog() {
            this.dialogVisible = true
        }
    }
}
</script>

<style>
.detect-dialog {
    border-radius: 6px;
}
</style>
<style scoped>
.detectip-box {
    width: 100dvw;
    height: 100dvh;
    background-color: #4F575D;
    display: flex;
    justify-content: center;
    align-items: center;
}
.db-wrapper {
    width: 1200px;
    text-align: center;
}
.db-site-name {
    color: #6AE7B5;
    font-size: 35px;
    font-weight: bold;
    margin-bottom: 15px;
}
.db-message {
    margin: 0;
    font-size: 22px;
    color: #FEFEFE;
}
.db-btns {
    margin-top: 20px;
}
.btn-p {
    margin: 0;
    display: flex;
    justify-content: center;
}
.hover-status:hover {
    color: #fff;
}
.detect-items {
    display: flex;
    flex-direction: column;
    max-height: 300px;
    overflow: auto;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
}
.detect-item {
    padding-bottom: 10px;;
}
.detect-item {
  padding: 12px 16px;
  border-bottom: 1px solid #e0e0e0;
  transition: background 0.2s ease-in-out;
}

.detect-item:last-child {
  border-bottom: none;
}

.detect-item:hover {
  background-color: #e6f7ff;
  cursor: pointer;
}
@media (max-width: 768px) {
    .db-wrapper {
        width: 100%;
        padding: 0 10px;
    }
    .dblist-btn {
        width: 100%;
        margin-left: 0;
        margin-top: 10px;
    }
    .hover-status {
        width: 100%;
    }
    .db-message {
        font-size: 16px;
    }
}
</style>